import React from "react";
import { Text, Button } from "design-system";
import { getAppsmithConfigs } from "ee/configs";
import {
  APPSMITH_DISPLAY_VERSION,
  createMessage,
  RELEASE_TIME,
} from "ee/constants/messages";
import moment from "moment";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { getCurrentUser } from "selectors/usersSelectors";
import { IntercomConsent } from "../HelpButton";
import classNames from "classnames";
import { DOCS_BASE_URL } from "constants/ThirdPartyConstants";
const { appVersion, cloudHosting, intercomAppID } = getAppsmithConfigs();

interface HelpItem {
  label: string;
  link?: string;
  id?: string;
  icon: string;
}
const HELP_MENU_ITEMS: HelpItem[] = [
  {
    icon: "book-line",
    label: "文档",
    link: DOCS_BASE_URL,
  },
  {
    icon: "bug-line",
    label: "报告一个bug",
    link: "https://github.com/cloudtogo/pageplug/issues",
  },
];

if (intercomAppID && window.Intercom) {
  HELP_MENU_ITEMS.push({
    icon: "chat-help",
    label: "联系我们",
    id: "intercom-trigger",
  });
}

const StyledText = styled(Text)`
  font-size: 8px;
  font-weight: normal;
`;

const HelpFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

function HelpMenu(props: {
  setShowIntercomConsent: (val: boolean) => void;
  showIntercomConsent: boolean;
}) {
  const user = useSelector(getCurrentUser);

  return (
    <div
      className={classNames({
        "mt-3.5": !props.showIntercomConsent,
        "flex-1": true,
      })}
    >
      {props.showIntercomConsent ? (
        <IntercomConsent showIntercomConsent={props.setShowIntercomConsent} />
      ) : (
        <>
          <Text
            color="var(--ads-v2-color-bg-brand-secondary)"
            kind="heading-xs"
          >
            帮助 & 资源
          </Text>
          <div className="flex flex-wrap gap-2 mt-2">
            {HELP_MENU_ITEMS.map((item) => {
              return (
                <Button
                  key={item.label}
                  kind="secondary"
                  onClick={(e: any) => {
                    if (item.link) {
                      window.open(item.link, "_blank");
                    }
                    if (item.id === "intercom-trigger") {
                      e?.preventDefault();
                      if (intercomAppID && window.Intercom) {
                        if (user?.isIntercomConsentGiven || cloudHosting) {
                          window.Intercom("show");
                        } else {
                          props.setShowIntercomConsent(true);
                        }
                      }
                    }
                  }}
                  startIcon={item.icon}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
        </>
      )}
      {appVersion.id && (
        <HelpFooter className="mt-2">
          <StyledText color="var(--ads-v2-color-fg-muted)" kind={"action-s"}>
            {createMessage(
              APPSMITH_DISPLAY_VERSION,
              appVersion.edition,
              appVersion.id,
            )}
          </StyledText>
          <StyledText color="var(--ads-v2-color-fg-muted)" kind={"action-s"}>
            {appVersion.releaseDate
              ? moment(appVersion.releaseDate).fromNow()
              : moment(RELEASE_TIME).fromNow()}{" "}
            发布
          </StyledText>
        </HelpFooter>
      )}
    </div>
  );
}

export default HelpMenu;
